import { useEffect, useState } from 'react';
import {
  getWhatsappButtonSettings,
  DEFAULT_WHATSAPP_BUTTON,
  type WhatsappButtonSettings,
} from '@/services/finances';
import { useMetaPixel } from '@/context/MetaPixelContext';

function toWhatsAppLink(number: string): string {
  const digits = number.replace(/\D/g, '');
  return `https://wa.me/${digits}`;
}

// Botón flotante de WhatsApp con burbuja de texto. Se ubica en la esquina
// inferior izquierda (al lado contrario del perrito de donaciones) y abre un
// chat directo al número oficial configurado en company_settings.
export default function FloatingWhatsapp() {
  const [settings, setSettings] = useState<WhatsappButtonSettings>(DEFAULT_WHATSAPP_BUTTON);
  const [dismissed, setDismissed] = useState(false);
  const { track } = useMetaPixel();

  useEffect(() => {
    let cancelled = false;
    getWhatsappButtonSettings().then((s) => {
      if (!cancelled) setSettings(s);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (dismissed || !settings.enabled || !settings.whatsapp.trim()) return null;

  return (
    <div className="hidden md:flex fixed md:bottom-5 left-4 md:left-5 z-40 flex-col items-start gap-2">
      <div className="max-w-[190px] md:max-w-[240px] bg-white border border-background-200 rounded-2xl rounded-bl-sm px-3.5 py-2 md:px-4 md:py-2.5 text-left shadow-sm animate-bubble-float">
        <p className="text-xs md:text-sm font-medium text-foreground-800 leading-snug">{settings.bubbleText}</p>
      </div>

      <div className="relative">
        <a
          href={toWhatsAppLink(settings.whatsapp)}
          target="_blank"
          rel="noreferrer noopener"
          aria-label="Escribir por WhatsApp"
          onClick={() => track('Lead', { content_name: 'WhatsApp', currency: 'COP', value: 0 })}
          className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-emerald-500 hover:bg-emerald-600 transition-colors flex items-center justify-center ring-4 ring-emerald-100 animate-dog-walk cursor-pointer"
        >
          <i className="ri-whatsapp-line text-white text-2xl md:text-3xl"></i>
        </a>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          aria-label="Ocultar WhatsApp"
          className="absolute -top-1 -right-1 w-6 h-6 rounded-full bg-white border border-background-200 text-foreground-500 hover:text-foreground-800 flex items-center justify-center cursor-pointer"
        >
          <i className="ri-close-line text-sm"></i>
        </button>
      </div>
    </div>
  );
}